import PropTypes from 'prop-types';
import React from 'react';
import { Size, Dim } from '../../constants/components';
import Popup from './Popup';
import TimedView from '../timer/TimedView';

export default class MessagePopup extends TimedView {
    componentDidMount() {
        if (this.props.delayedCallback) {
            this.scheduleEvent('MessagePopupDelayedCallback',
                this.props.delayedCallback, this.props.delay);
        }
    }

    componentWillUnmount() {
        this.resetTimers();
    }

    render() {
        return (
            <Popup
                buttons={this.props.buttons}
                backgroundDim={this.props.backgroundDim}
                fontSize={this.props.fontSize}>
                {this.props.message}
            </Popup>
        );
    }
}

MessagePopup.propTypes = {
    delayedCallback: PropTypes.func,
    delay: PropTypes.number,
    message: PropTypes.string.isRequired,
    buttons: PropTypes.arrayOf(PropTypes.element),
    fontSize: PropTypes.oneOf([Size.SMALL, Size.NORMAL]),
    backgroundDim: PropTypes.oneOf([Dim.NONE, Dim.CENTER, Dim.FULL]),
};

MessagePopup.defaultProps = {
    delayedCallback: undefined,
    delay: 0,
    buttons: undefined,
    fontSize: Size.NORMAL,
    backgroundDim: Dim.NONE,
};

MessagePopup.displayName = 'MessagePopup';
